import {gql} from "@apollo/client";

export const GET_FILE_PRESIGNED_URL = gql`
	query FilePresignedUrl($id: Int!, $entityType: EntityType!,$fileName: String!, $httpVerb: HttpVerb! )
	{
	   filePresignedUrl(input: {id :$id, fileName: $fileName, httpVerb: $httpVerb, entityType: $entityType}) { url, contentType }
	}
`;
